import React, {Fragment} from 'react';
import {Outlet} from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';
import Main from './Main';

/**
 * MarketingLayout is the main layout component for marketing pages, including header, main content, and footer.
 * Should be used in route configuration as the main layout for marketing pages.
 *
 * @component
 * @returns {JSX.Element} The rendered marketing layout.
 */
const MarketingLayout = () => {
  return (
    <Fragment>
      <Header />
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </Fragment>
  );
};

export default MarketingLayout;
